export function Publish(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.1332 7.99987C2.1332 4.7598 4.7598 2.1332 7.99987 2.1332C11.2399 2.1332 13.8665 4.7598 13.8665 7.99987C13.8665 10.9231 11.7285 13.347 8.93089 13.7931L8.9332 13.7472V6.99477L11.1126 8.86256C11.448 9.15009 11.9531 9.11125 12.2406 8.77578C12.509 8.46269 12.493 8.00187 12.217 7.70804L12.1538 7.64775L9.0877 5.01963C8.56896 4.57499 7.81721 4.55029 7.27258 4.94552L7.17871 5.01963L4.11257 7.64775C3.77711 7.93528 3.73826 8.44032 4.0258 8.77578C4.29417 9.08888 4.752 9.1436 5.0846 8.91572L5.15384 8.86256L7.3332 6.99477V13.7472C7.3332 13.775 7.33462 13.8025 7.33739 13.8295C4.40921 13.5005 2.1332 11.016 2.1332 7.99987ZM7.99987 0.533203C3.87614 0.533203 0.533203 3.87614 0.533203 7.99987C0.533203 12.1236 3.87614 15.4665 7.99987 15.4665C12.1236 15.4665 15.4665 12.1236 15.4665 7.99987C15.4665 3.87614 12.1236 0.533203 7.99987 0.533203Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
